
import { useState, useEffect } from 'react';
import client from '../../contentfulClientToken';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { optimizeContentfulImage } from '../../utils/imageOptimization';

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { INLINES } from '@contentful/rich-text-types';

gsap.registerPlugin(ScrollTrigger);

export default function PageConcept() {
    const [conceptData, setConceptData] = useState(null);

    useEffect(() => {
        const fetchPage = async () => {
            try {
                const response = await client.getEntries({ content_type: 'concept' });

                if (response.items.length > 0) {
                    const { albumPhoto01, nomPage, texte, url, titre } = response.items[0].fields;

                    setConceptData({ albumPhoto01, nomPage, texte, url, titre });
                }
            } catch (error) {
                console.error('Error fetching concept data:', error);
            }
        };

        fetchPage();
    }, []);

    // Allow editors to add classes via special hyperlink syntax in Contentful:
    // Select text -> add link with URL like: "span:highlight" or "span:highlight,emphasis"
    // This will render as <span class="highlight emphasis">...</span>
    const allowedSpanClasses = ['highlight', 'emphasis', 'note', 'small'];

    const renderOptions = {
        renderText: text =>
            text.split('\n').reduce((children, textSegment, index) => {
                return [...children, index > 0 && <br key={index} />, textSegment];
            }, []),
        renderNode: {
            [INLINES.HYPERLINK]: (node, children) => {
                const { uri } = node.data;
                // Custom syntax to render a span with classes instead of a link
                if (typeof uri === 'string' && uri.trim().toLowerCase().startsWith('span:')) {
                    const raw = uri.slice(5).trim();
                    // Support comma or space separated list of classes
                    const requested = raw
                        .split(/[,\s]+/)
                        .map((c) => c.trim())
                        .filter(Boolean);
                    // Whitelist classes to avoid injecting arbitrary class names
                    const classes = requested.filter((c) => allowedSpanClasses.includes(c));
                    const className = classes.join(' ') || 'highlight';
                    return <span className={className}>{children}</span>;
                }
                // Fallback to normal hyperlink rendering
                return (
                    <a href={uri} target="_blank" rel="noopener noreferrer">
                        {children}
                    </a>
                );
            },
        },
    };

    if (!conceptData) {
        return null; // Prevents rendering errors while data is loading
    }

    return (
        <section className="section-concept" data-content-type="concept" id="concept" data-background-color='#f4f4f4'>

            <div className='inner-container'>

                <div className="phrase" style={{ fontSize: '50px' }}>
                    {documentToReactComponents(conceptData.titre, renderOptions)}
                </div>


                {/*  <div className='title' >
                    <p >{conceptData.nomPage}</p>
                </div> */}

                {conceptData.albumPhoto01?.fields?.file?.url && (
                    <div className="pictures-container concept-pictures-mobile-padding">
                        <img
                            src={optimizeContentfulImage(conceptData.albumPhoto01.fields.file.url)}
                            alt='Labo Lol'
                            width={conceptData.albumPhoto01.fields.file.details?.image?.width}
                            height={conceptData.albumPhoto01.fields.file.details?.image?.height}
                        />
                    </div>
                )}

                <div className="description">
                    {documentToReactComponents(conceptData.texte, renderOptions)}
                </div>

            </div>

        </section>
    );
}
